export default __webpack_public_path__ + "static/media/userCheckFalse.b8ac301a.svg";